import React, { useState } from "react";
import AssetFailureMaster from "../AssetFailureMaster";
import StackedShiftWiseData from "./StackedShiftWiseData";
import MonthWise from "./AFSummary/MonthWise";
import HeadWise from "./AFSummary/HeadWise";
import AssetFailureYearly from "./AFSummary/AssetFailureYearly";
import StationSectionWise from "./AFSummary/StationSectionWise";
import { flattenData, months } from "../../../Utilitie";
import { color } from "echarts";
const AFSummary = ({ data }) => {
  const refMonths = months;
  const [activePage, setActivePage] = useState("Asset Failure Yearly");
  const tempData = flattenData(data);
  const years = [...new Set(tempData.map((t) => t.F_YEAR))].sort(
    (a, b) => Number(a.replace("_", "")) - Number(b.replace("_", ""))
  );
  const pageName = [
    "Asset Failure Yearly",
    "Station & Section Wise",
    "Month Wise",
    // "Head Wise",
  ];
  let tempMonths = [...new Set(tempData.map((t) => t["A_MONTH"]))];
  let month = tempMonths.sort(
    (a, b) =>
      refMonths.indexOf(a?.toUpperCase()) - refMonths.indexOf(b?.toUpperCase())
  );
  return (
    <div className="row m-1">
      <div
        className=" col-md-2 newUiBody  d-flex flex-column "
        style={{ height: "90vh" }}
      >
        {pageName.map((page) => {
          return (
            <button
              className={` col m-1 btn btn-sm btn-outline-dark Subject ${
                activePage === page && "active"
              }`}
              style={{ maxHeight: "50px" }}
              onClick={() => {
                setActivePage(page);
              }}
            >
              {page}
            </button>
          );
        })}
      </div>
      <div className="col-md-10 papDiv">
        {tempData && activePage === "Asset Failure Yearly" && (
          <AssetFailureYearly data={tempData} more={{ years: years }} />
        )}
        {tempData && activePage === "Station & Section Wise" && (
          <StationSectionWise data={tempData} more={{ years: years }} />
        )}
        {tempData && activePage === "Month Wise" && (
          <MonthWise data={tempData} more={{ years: years }} />
        )}
        {/* {activePage === "Head Wise" && (
          <HeadWise data={tempData} more={{ years: years }} />
        )} */}
      </div>
    </div>
  );
};
export default AFSummary;
